import React, { FC } from 'react';

import warning from './warning.svg';

export const Warning: FC = () => (
  <img src={warning} alt="Warning sign" width="56px" height="56px" />
);
